import { useLoaderData } from 'react-router';

import type { loader } from '~/routes/_app.product.$urlSegment';
import { DetailBackdropMark } from '~/ui-rocco/pages/detail-shared/DetailBackdropMark';

/**
 * The supplier's name behind the band under the gallery, set as project detail
 * sets the practice's behind its summary.
 *
 * The band's sections paint their own light ground, so a mark under them would
 * never show. It lies over them instead, at a few percent and multiplied: on
 * the ground it darkens to a soft grey shape, and on the type, already dark,
 * it changes nothing, so it reads as behind the page all the same. Above the
 * sections, below the sticky actions.
 */
export const ProductBackdropMark = () => {
    const { product } = useLoaderData<typeof loader>();
    return (
        <DetailBackdropMark
            name={product.Professional?.Title}
            className="z-20 opacity-[0.07] mix-blend-multiply"
        />
    );
};
